var _path, _path2, _path3, _line, _path4, _path5, _path6, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.438 9.82808V8.78443L15.6481 9.32859C16.1781 9.56694 16.7855 9.56297 17.3124 9.31771L18.5576 8.73804V9.82808C18.5576 10.9657 17.6354 11.8879 16.4978 11.8879C15.3602 11.8879 14.438 10.9657 14.438 9.82808Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5214 7.41079L17.1 5.89015C16.707 5.71549 16.2584 5.71549 15.8655 5.89015L12.444 7.41079C12.2434 7.49994 12.2434 7.7846 12.444 7.87374L15.8655 9.39439C16.2584 9.56905 16.707 9.56905 17.1 9.39439L20.5214 7.87374C20.722 7.7846 20.722 7.49994 20.5214 7.41079Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4704 13.4525C14.5734 13.4162 14.6791 13.3826 14.7872 13.3519C14.9625 13.302 15.1501 13.3556 15.2786 13.4813L16.1104 14.2951C16.3154 14.4956 16.6501 14.4956 16.8551 14.2951L17.6869 13.4813C17.8154 13.3556 18.003 13.302 18.1783 13.3519C19.6472 13.7698 20.6719 14.714 20.6719 15.8119C20.6719 16.3715 20.203 16.8252 19.6246 16.8252H15.6627",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.6445,
    y1: 8.39233,
    x2: 12.6445,
    y2: 10.0587,
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49777 7.83825V6.20216L6.76969 7.04885C7.22018 7.21674 7.71606 7.21674 8.16655 7.04885L10.4385 6.20216V7.83825C10.4385 9.47873 9.1086 10.8086 7.46812 10.8086C5.82764 10.8086 4.49777 9.47873 4.49777 7.83825Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3889 4.07451L8.37377 1.84557C7.79775 1.58956 7.14023 1.58956 6.56421 1.84557L1.5491 4.07451C1.2551 4.20517 1.2551 4.62243 1.5491 4.75309L6.56421 6.98203C7.14023 7.23804 7.79775 7.23804 8.37377 6.98203L13.3889 4.75309C13.6829 4.62243 13.6829 4.20517 13.3889 4.07451Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70397 12.991L6.92324 14.1838C7.22366 14.4777 7.71432 14.4777 8.01474 14.1838L9.23401 12.991C9.42236 12.8067 9.69733 12.7282 9.95431 12.8013C12.1074 13.4138 13.6094 14.7979 13.6094 16.4072C13.6094 17.2274 12.9221 17.8924 12.0743 17.8924H2.8637C2.01589 17.8924 1.3286 17.2274 1.3286 16.4072C1.3286 14.7979 2.83059 13.4138 4.98366 12.8013C5.24065 12.7282 5.51562 12.8067 5.70397 12.991Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.20117,
    y1: 5.28125,
    x2: 2.20117,
    y2: 8.30507,
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.5aa3cd3274a33edbe97dd5a1533f724a.svg";
export { ForwardRef as ReactComponent };